// hooks/useNeshanMap.js
import { useEffect, useState } from 'react'

export const useNeshanMap = () => {
  const [map, setMap] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.js'
    script.async = true
    script.onload = () => {
      setIsLoading(false)
      if (typeof L !== 'undefined') {
        let southWest = L.latLng(38.1798206357761, 48.21865389083308),
          northEast = L.latLng(38.30520008275403, 48.345629549549045),
          bounds = L.latLngBounds(southWest, northEast)

        const myMap = new L.Map('map', {
          key: 'web.2ef001c2f7df4cfb85a7a03fba096bfb',
          maptype: 'neshan',
          poi: false,
          traffic: false,
          center: [38.1798206357761, 48.21865389083308],
          zoom: 14,
          maxBounds: bounds,
          maxZoom: 18,
          minZoom: 10,
        })

        const initializedMap = myMap.setView([38.25122, 48.30991], 13)
        L.tileLayer('https://neshan.org/maps/{z}/{x}/{y}', {
          attribution: 'Map data &copy; <a href="https://neshan.org">Neshan</a>',
        }).addTo(initializedMap)

        setMap(initializedMap)
      }
    }
    script.onerror = () => {
      setError('Failed to load Neshan SDK.')
      setIsLoading(false)
    }

    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [])

  return { map, isLoading,setIsLoading, error }
}
